import React from "react";

const LoadingSpinner = () => {
  const spinnerStyle = {
    position: "absolute",
    top: "50%",
    left: "45%",
    transform: "translate(-50%, -50%)",
    border: "16px solid #00d1b2",
    borderTop: "16px solid #343434",
    borderRadius: "50%",
    width: "120px",
    height: "120px",
    animation: "spin 1s linear infinite",
  };

  const animationStyle = `
    @keyframes spin {
      0% { transform: rotate(0deg); }
      100% { transform: rotate(360deg); }
    }
  `;

  return (
    <div style={{ position: "relative", height: "100vh" }}>
      <style>{animationStyle}</style>
      <div style={spinnerStyle}></div>
    </div>
  );
};

export default LoadingSpinner;
